import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import AboutFAQ from "./AboutFAQ";
import { useTranslation } from "../../hooks/useTranslation";
// import useGetSiteImage from  "../../hooks/useGetSiteImage";


function AboutSection() {
  const { t } = useTranslation();
  // const exteriorImage = "exterior.jpg";
  // const { imageURL, error } = useGetSiteImage(exteriorImage);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box sx={{ textAlign: "center" }}>
          {/* <Typography variant="customFont" gutterBottom> */}
          <Typography variant="h1" sx={{ padding: "10px 0 10px 0" }}>
            {t('h1Title')}
          </Typography>

          <Typography variant="subtitle1" sx={{ padding: "0 10%" }}>
            {t('bestFoodBestPrices')}
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Grid
          container
          sx={{
            width: "100%",
            margin: "0 auto",
            display: "flex",
            justifyContent: "center",
            padding: "30px 0px",
          }}
        >
        <Grid item xs={12} sm={12} md={10} lg={7}>
        <img 
          // src={!error ? imageURL : ""}
          src={`${process.env.REACT_APP_CLIENT_URL}/images/exterior.jpg`}
          alt="Zielona Chatka Restaurant Exterior Building - Traditional Polish Restaurant in Białka Tatrzańska"
          style={{ width: "100%", border: 0 }}
          />
        </Grid>
        </Grid>
      </Grid>
      <Grid
          container
          sx={{
            width: "100%",
            margin: "0 auto",
            display: "flex",
            justifyContent: "center",
            paddingBottom: "150px",
          }}
        >
        <Grid item xs={11} sm={11} md={10} lg={7} sx={{backgroundColor: 'transparent'}}>
          <AboutFAQ />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default AboutSection;
